import React, { useState } from 'react'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import Cta from '../../../Cta'
import Modal from '../../../Modal'
import styles from './styles.module.css'
import CrossIcon from '../../../icons/CrossIcon'
import { Snackbar } from '@mui/material'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const theme = createTheme({
  components: {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          minWidth: 'fit-content !important',
        }
      }
    }
  }
})

function ContactFormSubmittedModal({ show, ticketId, message, onClose }) {
  const [openSnackbar, setOpenSnackbar] = useState(false)

  const copyTicketIdToClipboard = () => {
    setOpenSnackbar(true)
    navigator.clipboard.writeText(ticketId)
  }

  return (
    <Modal show={show} onClose={onClose}>
      <div className={styles.modalWrapper}>
        <Spacer size={32} />
        <button className={styles.closeButton} onClick={onClose}>
          <CrossIcon />
        </button>
        <Text type="h3">Thank you for contacting us!</Text>
        <Spacer size={32} />
        <Text type="body-short-2">{
          message ? message : 'Your request has been received and will be reviewed by our support staff as soon as possible.'
        } Your ticket ID is:</Text>
        <Spacer size={16} />
        <Text type="h2">{ticketId}</Text>
        <ThemeProvider theme={theme}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={openSnackbar}
            onClose={() => setOpenSnackbar(false)}
            autoHideDuration={2000}
            message="Copied to clipboard"
          />
        </ThemeProvider>
        <Spacer size={32} />
        <div className={styles.modalCtas}>
          <Cta title="Copy ticket ID" primary dark onClick={copyTicketIdToClipboard} />
        </div>
        <Spacer size={16} />
        <p className={styles.disclaimer}>Our response time for this type of requests is 24-36 hours during business days.</p>
        <Spacer size={32} />
      </div>
    </Modal>
  )
}

export default ContactFormSubmittedModal
